import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import {
    Button,
    Card,
    Container,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
// sections
// mock
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import EmtyData from 'src/components/emty-data';
import ComboboxImage from 'src/components/Input/ComboboxImage';
import Loader from 'src/components/loader/loader';
import DepartmentListHead from 'src/sections/@dashboard/department/DepartmentListHead';
import { FormatNumber, glb_sv, sendRequest, serviceList } from 'src/utils';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function ReportWareHouse() {
    const params = useParams();
    const arrFillters = useRef([]);
    const { t } = useTranslation();
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);

    const [order, setOrder] = useState('asc');

    const [selected, setSelected] = useState([]);

    const [orderBy, setOrderBy] = useState('name');

    const [cabinet, setcabinet] = useState({ cabinet_nm: t('all'), id: 0 });

    const [dataCabinet, setDataCabinet] = useState([]);
    const getRef = useRef(false);
    const tableRef = useRef(null);
    const [checked, setChecked] = useState('all');
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: t('export_ware_house'),

        sheet: t('export_ware_house'),
    });

    const TABLE_HEAD = [
        { id: 'Thao tác', label: 'STT', alignRight: false },
        { id: 'company', label: t('name_device'), alignRight: false },
        { id: 'name', label: t('code_device'), alignRight: false },
        { id: 'company', label: t('cabinet'), alignRight: false },
        { id: 'role', label: t('store'), alignRight: false },
        { id: 'role', label: 'Min/max', alignRight: false },
        { id: 'role', label: t('warning'), alignRight: false },
        { id: 'role', label: t('status'), alignRight: false },
        { id: 'role', label: t('supplier'), alignRight: false },
        { id: 'role', label: t('producer'), alignRight: false },
        { id: 'at_department', label: t('at_department'), alignRight: false },
        { id: 'role', label: t('price'), alignRight: false },
    ];

    const TABLE_HEAD_EXPORT = [
        { id: 'Thao tác', label: 'STT', alignRight: false },
        { id: 'company', label: t('name_device'), alignRight: false },
        { id: 'name', label: t('code_device'), alignRight: false },
        { id: 'company', label: t('cabinet'), alignRight: false },
        { id: 'drawer', label: t('drawer'), alignRight: false },
        { id: 'cell', label: t('cell'), alignRight: false },
        { id: 'role', label: t('store'), alignRight: false },
        { id: 'role', label: 'Min/max', alignRight: false },
        { id: 'role', label: t('warning'), alignRight: false },
        { id: 'role', label: t('status'), alignRight: false },
        { id: 'role', label: t('supplier'), alignRight: false },
        { id: 'role', label: t('producer'), alignRight: false },
        { id: 'at_department', label: t('at_department'), alignRight: false },
        { id: 'role', label: t('price'), alignRight: false },
    ];

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 600);
    }, [cabinet]);

    useEffect(() => {
        setTimeout(() => {
            getDataCabinet();
        }, 1000);
    }, []);

    const getDataCabinet = useCallback(() => {
        const InVal = [];
        sendRequest(serviceList.getAllCabinetSp, InVal, getDataCabinetResult, true, timeOutFunctCabinet, 40000);
    }, []);

    const getDataCabinetResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataCabinet([{ cabinet_nm: t('all'), id: 0 }, ...message.proc_data.rows[0].o_1]);
        }
    };
    const timeOutFunctCabinet = (reqInfo) => {};

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        const InVal = [cabinet?.id ? cabinet.id : 0];
        sendRequest(serviceList.reportWarehouse, InVal, getDataResult, true, timeOutFunct, 40000);
    }, [cabinet]);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows[0].o_1;
            // setTableData(message.proc_data.rows[0].o_1);
            arrFillters.current = message.proc_data.rows[0].o_1;
            if (checked === 'err') {
                const arr = data.filter((item) => item.err_key === 'er4' || item.err_key === 'er5');
                setTableData(arr);
            } else if (checked === 'no_err') {
                const arr = data.filter((item) => !item.err_key);
                setTableData(arr);
            } else {
                setTableData(data);
            }
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = tableData.map((n) => n.supplier_nm);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const onChangeCheck = (e) => {
        setChecked(e.target.value);
        if (e.target.value === 'err') {
            const arr = arrFillters.current.filter((item) => item.err_key === 'er4' || item.err_key === 'er5');
            setTableData(arr);
        } else if (e.target.value === 'no_err') {
            const arr = arrFillters.current.filter((item) => !item.err_key);
            setTableData(arr);
        } else {
            setTableData(arrFillters.current);
        }
    };
    return (
        <>
            <Helmet>
                <title> {t('quan_ly_bo_phan')} </title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4" gutterBottom>
                        {t('export_ware_house')}
                    </Typography>
                    <Button variant="contained" startIcon={<Iconify icon="ei:share-apple" />} onClick={onDownload}>
                        {t('export_excel')}
                    </Button>
                </Stack>{' '}
                <Breadcrumb
                    paths={[
                        {
                            label: t('xuat_bao_cao'),
                            url: `/home/export-report/${params.idPermission}`,
                            navigate: false,
                        },
                        { label: t('export_ware_house'), url: '#', navigate: false },
                    ]}
                />
                <Loader loading={getFlags} />
                <Card sx={{ padding: 2 }}>
                    <Grid container spacing={2} paddingBottom={2}>
                        <Grid item xl={6} md={6} sm={12} style={{ width: '100%', marginTop: 7 }}>
                            <ComboboxImage
                                label={t('choose_cabinet')}
                                sizeCbb="medium"
                                getValue={setcabinet}
                                valueSelect={cabinet}
                                displayImage="img_cabinet"
                                selectOption={dataCabinet?.filter((ele) => ele.block_status === '1')}
                                displayLabel="cabinet_nm"
                                autoFocus
                            />
                        </Grid>
                        <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                            <FormControl>
                                <FormLabel id="demo-row-radio-buttons-group-label">{t('bo_loc')}</FormLabel>
                                <RadioGroup
                                    row
                                    defaultValue="all"
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel
                                        value="all"
                                        control={<Radio onClick={onChangeCheck} />}
                                        label={t('all')}
                                    />
                                    <FormControlLabel
                                        value="err"
                                        control={<Radio onClick={onChangeCheck} />}
                                        label={t('warning')}
                                    />
                                    <FormControlLabel
                                        value="no_err"
                                        control={<Radio onClick={onChangeCheck} />}
                                        label={t('not_warning')}
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {/* <Scrollbar> */}
                    <TableContainer sx={{}}>
                        <Table>
                            <DepartmentListHead
                                order={order}
                                orderBy={orderBy}
                                headLabel={TABLE_HEAD}
                                rowCount={tableData.length}
                                numSelected={selected.length}
                                onRequestSort={handleRequestSort}
                                onSelectAllClick={handleSelectAllClick}
                            />
                            <TableBody>
                                {tableData.length > 0 &&
                                    tableData.map((item, index) => {
                                        return (
                                            <TableRow
                                                hover
                                                key={index}
                                                tabIndex={-1}
                                                role="checkbox"
                                                // selected={selectedUser}
                                            >
                                                <TableCell padding="checkbox"></TableCell>

                                                <TableCell align="left">{index + 1}</TableCell>
                                                <TableCell align="left">
                                                    {glb_sv.convertMultipleLanguages(item.device_nm)}
                                                </TableCell>
                                                <TableCell align="left">{item.device_cd}</TableCell>

                                                <TableCell align="left">
                                                    <Stack display={'flex'} flexDirection={'column'}>
                                                        <Typography
                                                            variant="subtitle3"
                                                            noWrap
                                                            sx={{ fontWeight: '600' }}
                                                        >
                                                            {t('cabinet')}: {item.cabinet_nm}
                                                        </Typography>
                                                        <Typography variant="subtitle3" noWrap>
                                                            {t('drawer')}: {item.drawer_nm}
                                                        </Typography>{' '}
                                                        <Typography variant="subtitle3" noWrap>
                                                            {t('cell')}:{' '}
                                                            {item?.cabinet_type === 'square'
                                                                ? `[ ${item?.cell_row || '--'} : ${
                                                                      item?.cell_column || '--'
                                                                  } ]`
                                                                : `[ ${item?.cell_column || '--'} ]`}
                                                        </Typography>
                                                    </Stack>
                                                </TableCell>
                                                <TableCell align="left" sx={{ minWidth: '100px' }}>
                                                    {FormatNumber(item.qty)}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item?.min_no ? item.min_no : 0}
                                                    {' -> '}
                                                    {item?.max_no ? item.max_no : 0}
                                                </TableCell>
                                                <TableCell align="left" sx={{ minWidth: item.err_mean ? '300px' : 0 }}>
                                                    <Typography color={'error'}>{item.err_mean}</Typography>
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item?.status_action === '1' ? t('take') : t('borrowing')}
                                                </TableCell>
                                                <TableCell align="left" sx={{ minWidth: '140px' }}>
                                                    {item.supplier_nm}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item?.prop_producer || ''}
                                                </TableCell>
                                                <TableCell align="left" sx={{ minWidth: 400 }}>
                                                    {item?.depart_json?.length > 0 &&
                                                        item.depart_json.map((depart_cd, idx) => {
                                                            let str = '';
                                                            str += depart_cd.label + ', ';
                                                            return str;
                                                        })}
                                                </TableCell>
                                                <TableCell align="left">{item.price}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                        {tableData.length === 0 && <EmtyData />}
                    </TableContainer>
                    {/* </Scrollbar> */}

                    {/* <Scrollbar> */}
                    <TableContainer sx={{}} style={{ display: 'None' }}>
                        <Table ref={tableRef}>
                            <DepartmentListHead
                                order={order}
                                orderBy={orderBy}
                                headLabel={TABLE_HEAD_EXPORT}
                                rowCount={tableData.length}
                                numSelected={selected.length}
                                onRequestSort={handleRequestSort}
                                onSelectAllClick={handleSelectAllClick}
                            />
                            <TableBody>
                                {tableData.length > 0 &&
                                    tableData.map((item, index) => {
                                        return (
                                            <TableRow
                                                hover
                                                key={index}
                                                tabIndex={-1}
                                                role="checkbox"
                                                // selected={selectedUser}
                                            >
                                                <TableCell padding="checkbox"></TableCell>

                                                <TableCell align="left">{index + 1}</TableCell>
                                                <TableCell align="left">
                                                    {glb_sv.convertMultipleLanguages(item.device_nm)}
                                                </TableCell>
                                                <TableCell align="left">{item.device_cd}</TableCell>
                                                <TableCell align="left">{item.cabinet_nm}</TableCell>
                                                <TableCell align="left">{item.drawer_nm}</TableCell>
                                                <TableCell align="left">
                                                    {item?.cabinet_type === 'square'
                                                        ? `[ ${item?.cell_row || '--'} : ${item?.cell_column || '--'} ]`
                                                        : `[ ${item?.cell_column || '--'} ]`}
                                                </TableCell>
                                                <TableCell align="left" sx={{ minWidth: '100px' }}>
                                                    {FormatNumber(item.qty)}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item?.min_no ? item.min_no : 0}
                                                    {' -> '}
                                                    {item?.max_no ? item.max_no : 0}
                                                </TableCell>
                                                <TableCell align="left" sx={{ minWidth: item.err_mean ? '140px' : 0 }}>
                                                    <Typography color={'error'}>{item.err_mean}</Typography>
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item?.status_action === '1' ? t('take') : t('borrowing')}
                                                </TableCell>
                                                <TableCell align="left" sx={{ minWidth: '140px' }}>
                                                    {item.supplier_nm}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item?.prop_producer || ''}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item?.depart_json?.length > 0 &&
                                                        item.depart_json.map((depart_cd, idx) => {
                                                            let str = '';
                                                            str += depart_cd.label + ', ';
                                                            return str;
                                                        })}
                                                </TableCell>
                                                <TableCell align="left">{item.price}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {/* </Scrollbar> */}
                </Card>
            </Container>
        </>
    );
}
